import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, instagram, yelp, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#F0343D" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/bukchon_yvr/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Bukchon Korean Cuisine Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#F0343D" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/bukchon_yvr/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Bukchon Korean Cuisine Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
